export default "__VITE_ASSET__Dgo2ektK__"